import { PipeTransform, Pipe } from "@angular/core";


@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {

  transform(value: number, isoCurrencyCode: string, locale?: string): string {
    return new Intl.NumberFormat(locale || navigator.language, { style: 'currency', currency: isoCurrencyCode  || 'USD' }).format(value)
  }
}